import '../styles/Footer.css';
import React from 'react';

export function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner" data-content-rail="primary">
        <div className="site-footer__text">
          <p className="site-footer__wordmark">dbaseextractor</p>
          <p className="site-footer__line">
            Crawls the web and web directories to find and extract email leads.
          </p>
        </div>
        <div className="site-footer__mark" aria-hidden="true">
          <svg viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
              x="1.5"
              y="1.5"
              width="45"
              height="33"
              rx="3"
              stroke="currentColor"
              strokeWidth="1.1"
            />
            <path
              d="M2.25 3.25 L24 20.5 L45.75 3.25"
              stroke="currentColor"
              strokeWidth="1.1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 33 C13.5 24.5 34.5 24.5 45.5 33"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="round"
              opacity="0.55"
            />
            <path
              d="M4.5 6.5 C14 2.8 34 2.8 43.5 6.5"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="round"
              opacity="0.35"
            />
          </svg>
        </div>
      </div>
    </footer>
  );
}

export default Footer;